/** Max concurrent tile image loads across all OSM overlay layers. */
const MAX_CONCURRENT_TILE_LOADS = 8;

let activeTileLoads = 0;
const pendingTileLoads: Array<() => void> = [];

function drainTileLoadQueue(): void {
  while (activeTileLoads < MAX_CONCURRENT_TILE_LOADS && pendingTileLoads.length > 0) {
    const next = pendingTileLoads.shift();
    next?.();
  }
}

/** Queue a tile `img` fetch so many overlay layers do not stampede the browser. */
export function scheduleOsmTileLoad(startLoad: () => void): void {
  const run = () => {
    activeTileLoads++;
    startLoad();
  };

  if (activeTileLoads < MAX_CONCURRENT_TILE_LOADS) {
    run();
    return;
  }
  pendingTileLoads.push(run);
}

export function releaseOsmTileLoad(): void {
  activeTileLoads = Math.max(0, activeTileLoads - 1);
  drainTileLoadQueue();
}
